import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Moment from "react-moment";
import FontAwesomeIcon from "../layout/IME/Icon";
import ToggleButton from "../PlayerButtons/ToggleButton";
import Volume from "../layout/Employers/Volume";
import Progress from "../layout/Employers/Progress";
import { getTourById } from "../../actions/vrtour";
import { getJobPostsById } from "../../actions/job";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import VRTourJob from "../layout/Employers/VRTourJob";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import Blocks from "../layout/IME/Blocks";

import JobPostItem from "../layout/Employers/JobPostItem";
import BlueSpinner from "../../img/Blue_Spinner.gif";

const VRTour = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  vrtour: { tour, tourloading },
  job: { jobs },
  getJobPostsById,
  getTourById,
  isAuthenticated,
}) => {
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  const [jobOpen, setJobOpen] = useState(false);
  const [activeView, setActiveView] = useState({ article: true, posts: false });
  const [showAuthentication, setShowAuthentication] = useState(true);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    getTourById(match.params.channelid, match.params._id);
    getJobPostsById(match.params.channelid);
  }, [getTourById, getJobPostsById]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavBlue />}
      {!isAuthenticated && <LoggedOutNav />}
      {tourloading ? (
        <div className="profile-error">
          <img src={BlueSpinner} alt="profile-red-spinner" />
        </div>
      ) : (
        <div className="flex-all-content-fixed">
          {jobOpen && <VRTourJob />}
          <section className="video-player-container border-bottom grey">
            <div className="video-player" ref={playerRef}>
              <div
                className={
                  showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
                }
              >
                <div className="user-overlay-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      tour && tour.avatar
                    }`}
                    className="streamer-user-avi"
                    alt="avatar"
                  />
                  <div className="stream-description-alt">
                    <p className="stream-username-title">
                      <span className="blue description-font mr-10">
                        {tour && tour.companyname}
                      </span>
                      <span className="white mr-5 description-font-alt">
                        {tour && tour.firstname}
                      </span>
                      <span className="white description-font-alt">
                        {tour && tour.lastname}
                      </span>
                    </p>
                    <p className="stream-p-description">
                      {tour && tour.tourtitle}
                    </p>
                    <div className="viewers">
                      <i className="fas fa-user fa-lg mr-5  blue"></i>
                      <span className="white bold">Views</span>{" "}
                      <span className="white bold mx-5">
                        {tour && tour.views.length}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="video-stream-icon blue">
                  <i className="fas fa-street-view fa-3x mx-5"></i>
                </div>
                <div className="alt-left-controls">
                  <ul className="controls">
                    <Volume
                      className="Rac__volume"
                      onChange={(level) => {
                        const volume = level / 100;
                        videoRef.current.volume = volume;
                        videoRef.current.muted = volume === 0;
                      }}
                    />
                  </ul>
                </div>
                <ToggleButton
                  className="alt-center-controls"
                  value={() => videoRef.current && !videoRef.current.paused}
                  onChange={(active) => {
                    if (!active) {
                      return videoRef.current.pause();
                    }

                    return videoRef.current.play();
                  }}
                >
                  {(active) => {
                    if (currentTime > 0.1 && currentTime < duration && active) {
                      setshowOverlay(true);
                      return (
                        <i
                          className="far fa-pause-circle blue fa-4x"
                          onClick={() => videoRef.current.pause()}
                        ></i>
                      );
                    } else {
                      setshowOverlay(false);
                    }
                    if (currentTime === duration) {
                      setCurrentTime(0);
                    } else if (currentTime === 0 && !active) {
                      return (
                        <i
                          className="far fa-play-circle blue fa-4x"
                          onClick={() => videoRef.current.play()}
                        ></i>
                      );
                    }
                    return (
                      <i
                        className="far fa-play-circle blue fa-4x"
                        onClick={() => videoRef.current.play()}
                      ></i>
                    );
                  }}
                </ToggleButton>
                <Progress
                  className="Rac__progress-bar"
                  initial={0}
                  time={currentTime}
                  duration={duration}
                  onSkip={(time) => (videoRef.current.currentTime = time)}
                />
                <div className="icon-flex-expand-settings-vr-tour">
                  <ToggleButton
                    className="Rac__screen-toggle"
                    initial={document.fullscreenElement}
                    onChange={(active) => {
                      if (!active && KeyboardEvent.key === "Escape") {
                        return document.exitFullscreen();
                      }

                      return playerRef.current.requestFullscreen({
                        navigationUI: "hide",
                      });
                    }}
                  >
                    {(active) => {
                      if (!active) {
                        return (
                          <FontAwesomeIcon
                            icon="expand"
                            size="lg"
                            className="blue"
                          />
                        );
                      }

                      if (active) {
                        return (
                          <FontAwesomeIcon
                            icon="compress"
                            size="lg"
                            className="blue"
                          />
                        );
                      }
                    }}
                  </ToggleButton>
                  <ToggleButton className="">
                    {(showSettings) => {
                      if (showSettings) {
                        return (
                          <div className="relative-button-container">
                            <li className="control blue">
                              <i className="fas fa-cog fa-lg icon-padding"></i>
                            </li>
                            <div className="video-settings">
                              <ul className="video-setting">
                                <li className="video-option blue bold">
                                  Quality
                                </li>
                                <li className="video-option white cursor">
                                  Auto
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option blue bold">
                                  Caption
                                </li>
                                <li className="video-option white cursor">
                                  Off
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option blue bold">
                                  Report Issue
                                </li>
                                <li className="video-option white cursor">
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option blue bold">
                                  Advanced
                                </li>
                                <li className="video-option white cursor">
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div className="relative-button-container">
                          <li className="control blue">
                            <i className="fas fa-cog fa-lg icon-padding"></i>
                          </li>
                        </div>
                      );
                    }}
                  </ToggleButton>
                </div>
              </div>
              <video
                ref={videoRef}
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_videos/${
                  tour && tour.tourvideo
                }`}
                poster={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_images/${
                  tour && tour.tourimage
                }`}
                className="video-view"
              ></video>
            </div>
          </section>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container-alt">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      tour && tour.avatar
                    }`}
                    className="streamer-user-avi"
                    alt="stream-avatar"
                  />
                  <p className="stream-description">{tour && tour.tourtitle}</p>
                </div>
                <div className="stream-lower-info">
                  <ul className="creator-stream-items">
                    <li className="stream-item blue bold">
                      {tour && tour.companyname}
                    </li>
                    <li className="stream-item white">
                      {tour && tour.firstname} {tour && tour.lastname}
                    </li>
                    <li className="stream-item">
                      {tour && tour.location.city},{" "}
                      {tour && tour.location.state}
                    </li>
                    <li className="stream-item">
                      <i className="far fa-clock mr-5 blue"></i>
                      <Moment format="MM/DD/YYYY">{tour && tour.date}</Moment>
                    </li>
                  </ul>
                  <ul className="user-count-items">
                    <li className="user-count-item">
                      <i className="fas fa-check fa-lg mr-5 blue"></i>
                      <span className="blue mr-5 bold">Followers</span>
                      <span className="blue bold">5,852</span>
                    </li>
                  </ul>
                  {isAuthenticated && (
                    <div className="action-buttons">
                      <div className="action-items-stream">
                        <div className="action-button blue">
                          <i className="far fa-thumbs-up action-icon fa-lg"></i>
                        </div>
                        <p className="action-text">5,768</p>
                      </div>
                      <div className="action-items-stream">
                        <div className="action-button blue">
                          <i className="far fa-thumbs-down action-icon fa-lg"></i>
                        </div>
                        <p className="action-text"></p>
                      </div>
                      <div className="action-items-stream">
                        <div className="action-button blue">
                          <i className="far fa-user action-icon-alt-two fa-lg"></i>
                        </div>
                        <p className="action-text">5,768</p>
                      </div>
                      <div className="action-items-stream">
                        <div className="action-button blue">
                          <i className="far fa-share-square action-icon fa-lg"></i>
                        </div>
                        <p className="action-text">Share</p>
                      </div>
                      <div className="action-items-stream">
                        <div className="action-button blue">
                          <i className="fas fa-check action-icon fa-lg"></i>
                        </div>
                        <p className="action-text">Follow</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="stream-grid-container">
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <section className="active-view-tour banner-hero">
            <p
              className="section-info-text blue bold"
              onClick={() => setActiveView({ article: true, posts: false })}
            >
              Tour Info
              {activeView.article && (
                <i className="far fa-check-circle fa-lg mx-5 blue"></i>
              )}
            </p>
            <p
              className="section-info-text blue bold"
              onClick={() => setActiveView({ article: false, posts: true })}
            >
              Job Posts
              {activeView.posts && (
                <i className="far fa-check-circle fa-lg mx-5 blue"></i>
              )}
            </p>
          </section>
          <section className="main-body-tour">
            {activeView.article && (
              <div className="article-p white">
                <Blocks blocks={tour && tour.tourblocks} />
              </div>
            )}
            {activeView.posts && jobs.length > 0 && (
              <div className="created-content">
                {jobs &&
                  jobs.isArray &&
                  jobs.map((jobpostitem) => {
                    return (
                      <div className="content-container">
                        <JobPostItem
                          jobpostitem={jobpostitem}
                          key={jobpostitem._id}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {activeView.posts && jobs.length <= 0 && (
              <p className="empty-content-alt blue">No Job Posts</p>
            )}
          </section>
        </div>
      )}
    </Fragment>
  );
};

VRTour.propTypes = {
  auth: PropTypes.object.isRequired,
  vrtour: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
  getTourById: PropTypes.func.isRequired,
  getJobPostsById: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  vrtour: state.vrtour,
  job: state.job,
});

export default connect(mapStateToProps, { getTourById, getJobPostsById })(
  VRTour
);
